import {ReactNode, useEffect, useMemo} from 'react'
import {useNavigate} from 'react-router-dom'
import {FeatureModelCode} from '../../../models/FeatureModel'
import {useAuth} from '../hooks/useAuth'

export interface AuthProtectedLayoutProps {
  adminOnly?: boolean
  featureCode?: FeatureModelCode
  children?: ReactNode
  emailTest?: RegExp
}

export const AuthProtectedLayout = ({
  children,
  adminOnly,
  featureCode,
  emailTest,
}: AuthProtectedLayoutProps) => {
  const {user, userCanReadFeature} = useAuth()
  const navigate = useNavigate()
  const canRead = useMemo(() => {
    if (user) {
      const isValidEmail = emailTest ? emailTest.test(user.email) : true
      if (adminOnly) {
        return user.isAdmin === true && isValidEmail
      }
      if (featureCode) {
        return userCanReadFeature(featureCode) && isValidEmail
      }
    }
    return !!user
  }, [adminOnly, emailTest, featureCode, user, userCanReadFeature])

  useEffect(() => {
    if (!canRead) {
      navigate(`/`, {replace: true})
    }
  }, [canRead, navigate])

  if (!user || !canRead) {
    return null
  }

  return <>{children}</>
}
